import { useCallback, useEffect, useState } from "react";
import dataProvider from "@podravka/data-provider";

import useAuthGuard from "./useAuthGuard";
import { useOneElastic } from "./useElastic";
import useUser from "./useUser";

const useFollowUser = (userId) => {
    const { profile: loggedInUser = {} } = useUser();

    // NOTE: Same for all users
    const taxonId = "4295a5e0-610d-11eb-85d8-0242ac120010";

    const { data } = useOneElastic({
        resource: "moj-profil",
        id: loggedInUser?.id,
        endpoint: `pratim/${userId}`,
    });

    const contentTaxonId = data[0]?.content_taxon_id || [];

    const authGuard = useAuthGuard();
    const [isFollowed, setIsFollowed] = useState(false);
    useEffect(() => {
        setIsFollowed(!!data?.length);
    }, [data]);
    const buttonTitle = isFollowed ? "Prestani pratiti" : "Počni pratiti";
    const sendFollowUser = useCallback(
        async (endpoint, payload) =>
            fetch(`${process.env.NEXT_PUBLIC_PODRAVKAIO_ROOT}/users/${userId}/${endpoint}`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Accept-Language": "hr",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${dataProvider.getToken()}`,
                },
                body: JSON.stringify(payload),
            }),
        [],
    );

    const handleFollowUser = authGuard(async () => {
        if (!isFollowed) {
            await sendFollowUser("taxons/coolinarika-followed-by", {
                taxon: `/api/taxonomies/protected-coolinarika-flags/taxons/${taxonId}`,
            });
            setIsFollowed(true);
        }
        if (isFollowed) {
            await fetch(
                `https://api.coolinarika.com/api/v1/feed/moj-profil/${contentTaxonId}/pratim/${userId}`,
                {
                    method: "DELETE",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${dataProvider.getToken()}`,
                        "Accept-Language": "",
                    },
                },
            );
            setIsFollowed(false);
        }
    });

    return {
        buttonTitle,
        handleFollowUser,
        isFollowed,
    };
};

export default useFollowUser;
